<template>
  <div class="card-form">
    <b-card>
      <page-main
        :tableData="tableData"
        :tablePage="page"
        :loading="loading"
        @reload="reload"
        @openEditFormDialog="openEditFormDialog"
      >
        <page-header
          ref="header"
          slot="header"
          @query="getData"
          @reset="resetPage"
          @openEditFormDialog="openEditFormDialog"
        />
        <pagination
          size="mini"
          align="right"
          slot="pager"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </page-main>
      <el-dialog
        v-if="editFormDialogOptions.visible"
        show-close
        visible
        width="700px"
        :title="editFormDialogOptions.title"
        :close-on-click-modal="false"
        :before-close="() => $refs.editForm.cancel()"
      >
        <accessories-edit-form
          ref="editForm"
          :accessoriesCode="editFormDialogOptions.accessoriesCode"
          :categoryCode="editFormDialogOptions.categoryCode"
          :disabled="editFormDialogOptions.disabled"
          :params="editFormDialogOptions.params"
          @reload="reload"
          @close="closeEditFormDialog"
        />
        <span slot="footer">
          <el-button size="small" @click="$refs.editForm.cancel()"
            >{{this.$l('INDEX.btn_cancel') || '取消'}}</el-button
          >
          <el-button type="primary" size="small" @click="$refs.editForm.save()"
            >{{this.$l('INDEX.btn_save') || '保存'}}</el-button
          >
        </span>
      </el-dialog>
    </b-card>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import AccessoriesEditForm from '../edit-form/index'
import store from '../../store'
export default {
  components: {
    PageHeader,
    PageMain,
    AccessoriesEditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
  },
  watch: {
    selected() {
      this.getData()
    },
  },
  methods: {
    getData(form) {
      if (!this.selected || !this.selected.categoryCode) return
      this.loading = true
      this.$api
        .masterAccessoriesRightListApi({
          categoryCode: this.selected.categoryCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({type, params = {}}) {
      if (!this.selected || !this.selected.categoryCode) {
        this.$message.warning(this.$l('form_label_tip_select_category') ||'请选选择一个大类')
        return
      }
      const types = {
        edit: this.$l('form_label_accessories_edit') ||'编辑辅料库明细信息',
        add: this.$l('form_label_accessories_add') ||'添加辅料库明细信息',
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        accessoriesCode: params.accessoriesCode,
        // bizSysDictCode: this.selected.bizSysDictCode,
        categoryCode: this.selected.categoryCode,
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
